import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import { FaCloud, FaArchway, FaCode, FaBolt, FaGlobe } from 'react-icons/fa';

export function About() {
  const [yearsExp,setYearsExp] = useState('15')
  const aboutText = "Senior Software Engineer & Full Stack Architect with "+ yearsExp +" years of experience delivering high-scale enterprise platforms. A business-oriented problem solver specializing in transforming rigid legacy systems into high-performance architectures, proven by driving 4–6× faster API response times and eliminating 70% of redundant backend code. I am recognized for restoring stakeholder trust in challenging environments by delivering proactive, 'value-add' features beyond initial requirements. I engineered a type-safe JPA abstraction framework that reduced development effort by 60%and optimized cloud infrastructure to achieve an 80% reduction in costs. A pioneer in Generative AI integration, I architected solutions for automated production root-cause analysis while leading teams to maintain 100% code coverage across Java 25 and Spring Boot 3.5 microservices";

  useEffect(() =>{
    const startDate = new Date('2009-05-07');  
    const today = new Date();
    const years = (today - startDate)/31536000000;
    setYearsExp(years.toFixed(1));
    },[]);

  const textVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
      },
    },
  };

  const wordVariants = {
    hidden: { opacity: 0, y: 8 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3, ease: 'easeOut' },
    },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { 
        duration: 0.8, 
        ease: [0.25, 0.4, 0.25, 1],
        opacity: { duration: 0.6 }
      }
    }
  };

  const scaleIn = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { 
        duration: 0.8, 
        ease: [0.25, 0.4, 0.25, 1]
      }
    }
  };

  const stagger = {
    visible: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.3
      }
    }
  };

  const skills = [
    { icon: <FaCloud size={18} />, text: 'Cloud-native architecture & microservices' },
    { icon: <FaArchway size={18} />, text: 'Enterprise system design & scalability' },
    { icon: <FaCode size={18} />, text: 'Full-stack development (Java, React, Spring Boot)' },
    { icon: <FaBolt size={18} />, text: 'GenAI/Copilot adoption & DevOps excellence' },
    { icon: <FaGlobe size={18} />, text: 'Languages: Tamil, English, Hindi, Kannada, Marathi' },
  ];

  return (
    <motion.section
      id="about"
      className="section"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
      variants={fadeUp}
    >
      <motion.h3 className="about-title" variants={fadeUp}>ABOUT</motion.h3>
      <motion.p 
        className="text" 
        variants={textVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.4 }}
      >
        {aboutText.split(" ").map((word, index) => (
          <motion.span key={index} variants={wordVariants} style={{ display: 'inline-block', marginRight: '0.35em' }}>
            {word}
          </motion.span>
        ))}
      </motion.p>

      <motion.ul className="list" variants={stagger} initial="hidden" whileInView="visible" viewport={{ once: false, amount: 0.3 }}>
        {skills.map((skill, index) => (
          <motion.li key={index} variants={fadeUp}>
            <span className="list-icon">{skill.icon}</span>
            <span className="list-text">{skill.text}</span>
          </motion.li>
        ))}
      </motion.ul>

      <motion.a className="btn ghost about-download" href="/Sathish-Kalaimani-Resume.pdf" download variants={scaleIn}>DOWNLOAD CV</motion.a>
    </motion.section>
  );
}
